<div class="loader-state-wrapper">
  @if (heading()) {
  <h2>{{ heading() }}</h2>
  } @switch (state().loadingState) { @case (LoadingState.Loading) {
  <!-- loader -->
  <div class="loader-state">
    <webstore-card-loader></webstore-card-loader>
  </div>
  } @case (LoadingState.Loaded) {
  <!-- content -->
  <ng-content></ng-content>
  } @case (LoadingState.Error) {
  <!-- server error -->
  <div class="server-error-state">
    <webstore-server-error></webstore-server-error>
  </div>
  } }
</div>
